import classnames from 'classnames/bind'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'

import ReadMoreText from '~/components/UI/ReadMoreText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type EditorialTextReadMoreProps = {
  className?: string
  text?: string
  limit?: number
}

function EditorialTextReadMore({
  className,
  text,
  limit,
}: EditorialTextReadMoreProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Text14GroteskRegular,
  })

  return (
    <div className={cx(css.EditorialTextReadMore, className, gridStyle)}>
      {text && (
        <ReadMoreText
          className={cx(css.text, textStyle)}
          charsLimit={limit}
          text={text}
        />
      )}
    </div>
  )
}

EditorialTextReadMore.defaultProps = {
  limit: 200,
}

export default EditorialTextReadMore
